var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDocsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88894 6.11111V12.3333C6.88894 13.1924 7.58539 13.8889 8.4445 13.8889H13.1112M6.88894 6.11111V4.55556C6.88894 3.69645 7.58539 3 8.4445 3H12.0112C12.2175 3 12.4153 3.08194 12.5612 3.22781L15.9945 6.66108C16.1403 6.80694 16.2223 7.00478 16.2223 7.21106V12.3333C16.2223 13.1924 15.5258 13.8889 14.6667 13.8889H13.1112M6.88894 6.11111H5.77783C4.67326 6.11111 3.77783 7.00654 3.77783 8.11111V15.4444C3.77783 16.3036 4.47428 17 5.33339 17H11.1112C12.2157 17 13.1112 16.1046 13.1112 15V13.8889",
    stroke: "#171717",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsActive);
export default __webpack_public_path__ + "static/media/docs-active.077450e92eed6d58a089a08e591c4fde.svg";
export { ForwardRef as ReactComponent };